var filterWrap = document.querySelector('.filterWrap');

if (filterWrap) {
    var banner = document.querySelector('.banner');
    var footer = document.querySelector('.footer');
    var body = document.body;

    // Track visibility of banner and footer
    let isBannerVisible = true;
    let isFooterVisible = true;

    // Update the body class based on banner and footer visibility
    function updateBodyClass() {
        if (!isBannerVisible) {
            body.classList.add('__filters-sticky');
            body.classList.remove('__filters-sticky-bottom');

            if (isFooterVisible) {
                body.classList.add('__filters-sticky-bottom');
                body.classList.remove('__filters-sticky');
            }
        }
        else {
            body.classList.remove('__filters-sticky');
        }
    }

    // Check if the IntersectionObserver is supported
    if ('IntersectionObserver' in window) {
        // Set up the observer
        var observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.target === banner) {
                    isBannerVisible = entry.isIntersecting;
                } else if (entry.target === footer) {
                    isFooterVisible = entry.isIntersecting;
                }
                updateBodyClass(); // Call function to check if class should be added or removed
            });
        });

        // Start observing the .banner and .footer elements
        observer.observe(banner);
        observer.observe(footer);
    }
    else {
        // Fallback for browsers that do not support IntersectionObserver
        console.warn('IntersectionObserver is not supported by this browser.');
    }
};